import { defineMessages } from 'react-intl';

const scope = 'app.workspace.importProgressIndicator';

export default defineMessages({
  progressIndicator: {
    id: `${scope}.progressIndicator`,
    defaultMessage: 'This may take a while',
  },
  importingProgressIndicator: {
    id: `${scope}.importingProgressIndicator`,
    defaultMessage: 'This might take 1 hour or more',
  },
});
